export default __webpack_public_path__ + "static/media/oscer-pres-seizure.531650a2.svg";